import {
  GET_PAYMENT_REQUEST_DATA,
  GET_PAYMENT_REQUEST_DATA_SUCCESS,
  GET_PAYMENT_REQUEST_DATA_FAILURE,
  GET_PAYMENT_COMPLETE_DATA,
  GET_PAYMENT_COMPLETE_DATA_SUCCESS,
  GET_PAYMENT_COMPLETE_DATA_FAILURE,
} from "./actionType";

const initialData = {
  paymentRequestData: [],
  paymentRequestDataLoading: false,

  paymentCompleteData: [],
  paymentCompleteDataLoading: false,
};

const PublicPayment = (state = initialData, action) => {
  switch (action.type) {
    case GET_PAYMENT_REQUEST_DATA:
      return {
        ...state,
        paymentRequestDataLoading: true,
      };
    case GET_PAYMENT_REQUEST_DATA_SUCCESS:
      return {
        ...state,
        paymentRequestData: action.payload,
        paymentRequestDataLoading: false,
      };
    case GET_PAYMENT_REQUEST_DATA_FAILURE:
      return {
        ...state,
        paymentRequestDataLoading: false,
      };
    case GET_PAYMENT_COMPLETE_DATA:
      return {
        ...state,
        paymentCompleteDataLoading: true,
      };
    case GET_PAYMENT_COMPLETE_DATA_SUCCESS:
      return {
        ...state,
        paymentCompleteData: action.payload,
        paymentCompleteDataLoading: false,
      };
    case GET_PAYMENT_COMPLETE_DATA_FAILURE:
      return {
        ...state,
        paymentCompleteDataLoading: false,
      };
    default:
      return state;
  }
};

export default PublicPayment;
